import axios from 'axios';
import React, { createContext, useEffect, useState } from 'react';
import domain from '../util/domain';

const UserContext = createContext();

function UserContextProvider(props) {
	const [user, setUser] = useState(undefined);

	async function getUser() {
		const userRes = await axios.get(`${domain}/auth/loggedIn`);
		setUser(userRes.data);
	}

	// LOGOUT USER
	async function logOut() {
		if (user) {
			await axios.get(`${domain}/auth/logOut`);
		}
		window.location.reload();
	}

	useEffect(() => {
		getUser();
	}, []);

	return (
		<UserContext.Provider value={{ user, getUser, logOut }}>
			{props.children}
		</UserContext.Provider>
	);
}

export default UserContext;
export { UserContextProvider };
